// src/constants/fishIQ.ts
// Central place for FishIQ colors + restricted zones (and any other FishIQ constants)

import type { RestrictedZone } from '../../src/types';

// Light theme colors for species
export const speciesColors: Record<string, string> = {
  Bass: '#22c55e',
  Largemouth: '#16a34a',
  Smallmouth: '#22c55e',
  Trout: '#0ea5e9',
  Rainbow: '#38bdf8',
  Brown: '#0ea5e9',
  Salmon: '#fb7185',
  Crappie: '#facc15',
  Panfish: '#22d3ee',
  Catfish: '#a855f7',
  Walleye: '#f97316',
  Pike: '#f59e0b',
};

// Dark theme colors for species
export const speciesColorsDark: Record<string, string> = {
  Bass: '#4ade80',
  Largemouth: '#22c55e',
  Smallmouth: '#4ade80',
  Trout: '#38bdf8',
  Rainbow: '#7dd3fc',
  Brown: '#38bdf8',
  Salmon: '#fb7185',
  Crappie: '#facc15',
  Panfish: '#22d3ee',
  Catfish: '#c4b5fd',
  Walleye: '#fdba74',
  Pike: '#fbbf24',
};

/**
 * Demo / starter restricted zones.
 * You can tune these later, they’re just here so the map + warnings work.
 */
export const restrictedZones: RestrictedZone[] = [
  {
    id: 'tahoe-demo-no-wake',
    name: 'Demo No-Fishing Zone',
    reason: 'Protected shoreline demo area – adjust with real data later.',
    position: { lat: 39.0968, lng: -120.0324 },
    radiusMeters: 600,
  },
];
